import React, {ReactNode} from 'react'
import {Box} from "@mui/material"
import {
    SIDEBAR_WIDTH,
    SIDEBAR_WIDTH_COLLAPSED,
    RIGHT_SIDEBAR_WIDTH,
    RIGHT_SIDEBAR_WIDTH_COLLAPSED,
    TOP_NAV_HEIGHT,
    CONTENT_BG,
} from "./layoutConstants"
import {useSidebarCollapsed, useRightSidebarCollapsed} from "../../hooks/useCollapsible"

interface ContentAreaProps {
    children: ReactNode
}

function ContentArea({children}: ContentAreaProps) {
    const [sidebarCollapsed] = useSidebarCollapsed()
    const [rightSidebarCollapsed] = useRightSidebarCollapsed()

    const ml = sidebarCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH
    const mr = rightSidebarCollapsed ? RIGHT_SIDEBAR_WIDTH_COLLAPSED : RIGHT_SIDEBAR_WIDTH

    return (
        <Box
            sx={{
                ml: `${ml}px`,
                mr: `${mr}px`,
                mt: `${TOP_NAV_HEIGHT}px`,
                pt: 4,
                pb: 10,
                px: 4,
                minHeight: `calc(100vh - ${TOP_NAV_HEIGHT}px)`,
                bgcolor: CONTENT_BG,
                transition: 'margin-left 200ms ease, margin-right 200ms ease',
            }}
        >
            {children}
        </Box>
    )
}

export default ContentArea
